<mat-icon class="{{vAlign}} cursor-style" [matTooltip]="helpText">help</mat-icon>
